export default {
    props: {
        virtualItemHeight: {
            type: Number,
            default: undefined,
            kComposite: 'virtual.itemHeight'
        }, 
        virtualMapValueTo: {
            type: String,
            default: undefined,
            kComposite: 'virtual.mapValueTo'
        }, 
        virtualValueMapper: {
            type: Function,
            default: undefined,
            kComposite: 'virtual.valueMapper'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/Common/Virtual.js